__webpack_require__.p = "https://bundle.stayforlong.com/20251210.5/_next/";